
import { SEO } from './SEO'
import { HeroSection } from './sections/HeroSection'
import { ThreePillarsModelSection } from './sections/ThreePillarsModelSection'
import { EspecialistasSection } from './sections/EspecialistasSection'
import { PorQueElegirnosSection } from './sections/PorQueElegirnosSection'
import { TestimoniosSection } from './sections/TestimoniosSection'
import { CTASection } from './CTASection'

interface HomePageProps {
	dictionary: any;
}

export function HomePage({ dictionary }: HomePageProps) {
  // Datos estructurados para SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "Neuro Peques",
    "description": dictionary.homepage?.hero?.subtitle,
    "url": "https://www.neuropequescr.com",
    "telephone": "+50685838056",
    "email": "info@neuropequescr.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Heredia, Costa Rica",
      "addressLocality": "Heredia",
      "addressCountry": "CR"
    },
    "medicalSpecialty": [
      "Neuropsicología Infantil",
      "Psicología Infantil", 
      "Psicopedagogía",
      "Terapia del Lenguaje",
      "Terapia Ocupacional",
      "Psiquiatría",
      // "Medicina General Infantil" // TEMPORALMENTE OCULTO
    ],
    "availableService": [
      {
        "@type": "MedicalService",
        "name": "Evaluación Neuropsicológica",
        "description": "Evaluación integral del neurodesarrollo infantil"
      },
      {
        "@type": "MedicalService", 
        "name": "Estimulación Cognitiva",
        "description": "Intervención terapéutica para potenciar el desarrollo cerebral"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/neuropequescr",
      "https://www.instagram.com/neuropequescr"
    ]
  };

  return (
    <>
      <SEO
        title={dictionary.homepage?.hero?.title}
        description={dictionary.homepage?.hero?.subtitle}
        keywords="neurodesarrollo infantil, neuropsicología infantil, TDAH, TEA, trastornos del aprendizaje, estimulación cognitiva, Costa Rica, Heredia, evaluación neuropsicológica, psicología infantil"
        canonical="https://www.neuropequescr.com"
        structuredData={structuredData}
      />
      
      <main>
        {/* Hero Section */}
        <HeroSection />
        
        {/* Three Pillars Model Section */}
        <ThreePillarsModelSection dictionary={dictionary} />
        
        {/* Especialistas Section */}
        <EspecialistasSection />
        
        {/* Por Qué Elegirnos Section (incluye Nuestra Meta) */}
        <PorQueElegirnosSection />
        
        {/* Testimonios Section */}
        <TestimoniosSection />
        
        {/* CTA Section */}
        <CTASection 
          title={dictionary.ctaSection?.defaultTitle}
          description={dictionary.ctaSection?.defaultDescription}
          buttonText={dictionary.ctaSection?.defaultButtonText}
        />
      </main>
    </>
  )
}
